// appVar.js
const appVar = {

    get gApiUrl() {
        return sessionStorage.getItem("gApiUrl") || "";
    },
    set gApiUrl(value) {
        sessionStorage.setItem("gApiUrl", value);
    },
    // Token de sesión del API (lo entrega ValidaLogin; se borra al volver al login)
    get gTokenApi() {
        return sessionStorage.getItem("gTokenApi") || "";
    },
    set gTokenApi(value) {
        if (value) {
            sessionStorage.setItem("gTokenApi", value);
        } else {
            sessionStorage.removeItem("gTokenApi");
        }
    },
    get gColorCorp() {
        return sessionStorage.getItem("gColorCorp") || "#7d5addff";
    },
    set gColorCorp(value) {
        sessionStorage.setItem("gColorCorp", value);
    },
    get gColorCorpTitle() {
        return sessionStorage.getItem("gColorCorpTitle") || "#a387f0ff";
    },
    set gColorCorpTitle(value) {
        sessionStorage.setItem("gColorCorpTitle", value);
    },
    get gColorCorpLabel() {
        return sessionStorage.getItem("gColorCorpLabel") || "#8d8a8aff";
    },
    set gColorCorpLabel(value) {
        sessionStorage.setItem("gColorCorpLabel", value);
    },
    // Color de la letra (texto e iconos) del menú lateral.
    get gColorLetraMenu() {
        return sessionStorage.getItem("gColorLetraMenu") || "rgba(255, 255, 255, 0.7)";
    },
    set gColorLetraMenu(value) {
        sessionStorage.setItem("gColorLetraMenu", value);
    },


    configLoaded: false,

    // Valores persistentes durante la sesión
    get siteKey() {
        return sessionStorage.getItem("siteKey") || "";
    },
    set siteKey(value) {
        sessionStorage.setItem("siteKey", value);
    },
    // reCAPTCHA v3 (solo Login). siteKey sigue siendo la v2 de las demás pantallas.
    get siteKeyV3() {
        return sessionStorage.getItem("siteKeyV3") || "";
    },
    set siteKeyV3(value) {
        sessionStorage.setItem("siteKeyV3", value);
    },

    get gCodUsuario() {
        return sessionStorage.getItem("gCodUsuario") || "";
    },
    set gCodUsuario(value) {
        sessionStorage.setItem("gCodUsuario", value);
    },
    get gNomUsuario() {
        return sessionStorage.getItem("gNomUsuario") || "";
    },
    set gNomUsuario(value) {
        sessionStorage.setItem("gNomUsuario", value);
    },
    get gNIT() {
        return sessionStorage.getItem("gNIT") || "";
    },
    set gNIT(value) {
        sessionStorage.setItem("gNIT", value);
    },
    get gOpcionReg() {
        return sessionStorage.getItem("gOpcionReg") || "";
    },
    set gOpcionReg(value) {
        sessionStorage.setItem("gOpcionReg", value);
    },
    get gCodRegional() {
        return sessionStorage.getItem("gCodRegional") || "";
    },
    set gCodRegional(value) {
        sessionStorage.setItem("gCodRegional", value);
    },
    get gNomRegional() {
        return sessionStorage.getItem("gNomRegional") || "";
    },
    set gNomRegional(value) {
        sessionStorage.setItem("gNomRegional", value);
        window.dispatchEvent(new CustomEvent("appvar:gNomRegional", { detail: value }));
    },
    get gCodOficina() {
        return sessionStorage.getItem("gCodOficina") || "";
    },
    set gCodOficina(value) {
        sessionStorage.setItem("gCodOficina", value);
    },
    get gDigitador() {
        return sessionStorage.getItem("gDigitador") || "";
    },
    set gDigitador(value) {
        sessionStorage.setItem("gDigitador", value);
    },
    get gBackground() {
        return sessionStorage.getItem("gBackground") || "/background.png";
    },
    set gBackground(value) {
        sessionStorage.setItem("gBackground", value);
    },
    get gTitle() {
        return sessionStorage.getItem("gTitle") || "";
    },
    set gTitle(value) {
        sessionStorage.setItem("gTitle", value);
    },

    get gFecProceso() {
        return sessionStorage.getItem("gFecProceso") || "";
    },
    set gFecProceso(value) {
        sessionStorage.setItem("gFecProceso", value);
    },

    // Limpia SOLO los datos de la sesión del usuario. NO borra los valores que
    // vienen de config.json (gApiUrl, gUserApi, gPassApi, colores, gBackground,
    // siteKey): esos se cargan una sola vez en index.js al abrir la
    // página, y si se borran la app queda sin URL del API ni reCAPTCHA hasta
    // que el usuario recargue (F5).
    clearSession() {
        sessionStorage.removeItem("gCodUsuario");
        sessionStorage.removeItem("gNomUsuario");
        sessionStorage.removeItem("gNIT");
        sessionStorage.removeItem("gCodRegional");
        sessionStorage.removeItem("gNomRegional");
        sessionStorage.removeItem("gCodOficina");
        sessionStorage.removeItem("gTitle");
        sessionStorage.removeItem("gOpcionReg");
        sessionStorage.removeItem("gDigitador");
        sessionStorage.removeItem("gFecProceso");
    },
};

export default appVar;
